import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import DispatchEntry from "@/pages/DispatchEntry";
import Register from "@/pages/Register";
import Reports from "@/pages/Reports";
import Masters from "@/pages/Masters";
import UsersPage from "@/pages/Users";
import AuditLog from "@/pages/AuditLog";
import PODReconcile from "@/pages/PODReconcile";
import ResetPassword from "@/pages/ResetPassword";
import "@/App.css";

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dispatch" element={<DispatchEntry />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pod" element={<PODReconcile />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/masters" element={<Masters />} />
            <Route path="/users" element={<AdminOnly><UsersPage /></AdminOnly>} />
            <Route path="/audit" element={<AuditLog />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
